'use client';

import {useState} from "react";
import Image from "next/image";
import {useTranslation} from "react-i18next";
import FirstStepForm from "@/app/[locale]/(auth)/register/multi-step-form/first-step-form/FirstStepForm";
import SecondStepForm from "@/app/[locale]/(auth)/register/multi-step-form/second-step-form/SecondStepForm";
import Role from "@/app/[locale]/(auth)/register/role/Role";
import {Provider} from "@/app/context/FormContext";
import classes from "./page.module.scss";
import Calendar from "../../../assets/images/registration/calendar.jpg";
import LeftArrow from "../../../assets/images/registration/left-arrow.svg";
import Logo from "../../../assets/images/header/seekintro-logo.svg";

const firstStepInitialState = {
    name: "",
    email: "",
    password: "",
};

const secondStepInitialState = {
    link: "",
    position: "",
    company: "",
    country_id: "",
    city_id: "",
    network: "",
};

const renderStep = (step) => {
    switch (step) {
        case 0:
            return <FirstStepForm/>;
        case 1:
            return <SecondStepForm/>;
        default:
            return null;
    }
};

const Register = () => {
    const {t} = useTranslation();
    const [firstStep, setFirstStep] = useState(firstStepInitialState);
    const [secondStep, setSecondStep] = useState(secondStepInitialState);
    const [currentStep, setCurrentStep] = useState(0);

    const next = () => {
        if (currentStep >= 1) {
            setCurrentStep(currentStep + 1);
            return;
        }
        setCurrentStep(currentStep + 1);
    };

    const prev = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    const renderContent = () => {
        if (currentStep > 1) {
            return <Role/>;
        }
        return (
            <>
                <div className={classes.container}>
                    <div className={classes.form}>
                        <div className={classes.progressRegistration}>
                            <div className={classes.progressFilled} style={{width: currentStep === 0 ? '50%' : '90%'}}/>
                        </div>
                        <h1 className={classes.title}>{t('registration.title')}</h1>
                        <p className={classes.description}>{t('registration.description')}</p>
                        <div className={classes.form}>
                            {renderStep(currentStep)}
                        </div>
                    </div>
                    <Image src={Calendar} alt="calendar" className={classes.calendar}/>
                </div>
            </>
        );
    };

    return (
        <Provider value={{firstStep, setFirstStep, next, prev, secondStep, setSecondStep}}>
            <main>
                <div className={classes.header}>
                    <Image src={Logo} alt={'logo'}/>
                </div>
                {currentStep > 0 && (
                    <div className={classes.image_container}>
                        <Image src={LeftArrow} alt="arrow" onClick={prev} className={classes.image}/>
                    </div>
                )}
                {renderContent()}
            </main>
        </Provider>
    );
};

export default Register;